<template>
    <div>
        <Pane>
            <span>{{ isEdit ? "票据编辑" : "票据新增" }}</span>
        </Pane>

        <div class="container">
            <a-form-model
                :model="formData"
                :label-col="{ span: 8 }"
                :wrapper-col="{ span: 12 }"
                :colon="false"
            >
                <div class="title">基础信息</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="票据类型">
                                <a-select v-model="formData.billType" placeholder="请选择票据类型" allow-clear>
                                    <a-select-option v-for="item in billTypeList" :key="item.value" :value="item.value">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="票据号码">
                                <a-input v-model="formData.billNo" placeholder="请输入票据号码" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="出票人">
                                <a-input v-model="formData.drawer" placeholder="请输入出票人" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="所属银行">
                                <a-select
                                    v-model="formData.bankName"
                                    placeholder="请选择所属银行"
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    allow-clear
                                >
                                    <a-select-option v-for="item in bankList" :key="item.value" :value="item.value">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="付款行">
                                <a-select
                                    v-model="formData.payBank"
                                    placeholder="请选择付款行"
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    allow-clear
                                >
                                    <a-select-option v-for="item in bankList" :key="item.value" :value="item.value">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="收款人">
                                <a-input v-model="formData.payee" placeholder="请输入收款人" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="出票日期">
                                <a-date-picker v-model="formData.issueDate" style="width:100%" placeholder="请选择日期" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="到期日期">
                                <a-date-picker v-model="formData.dueDate" style="width:100%" placeholder="请选择日期" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="出票金额">
                                <a-input v-model="formData.amount" placeholder="请输入金额">
                                    <template slot="suffix">元</template>
                                </a-input>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>

                <div class="title">来源信息</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="收票日期">
                                <a-date-picker v-model="formData.receiveDate" style="width:100%" placeholder="请选择日期" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="收票项目">
                                <ContractSelector @change="onSelectProject">
                                    <a-button block style="text-align: left" class="ellipsis">
                                        {{ formData.receiveContractName }}
                                    </a-button>
                                </ContractSelector>
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="收票部门">
                                <a-select
                                    v-model="formData.receiveDeptId"
                                    placeholder="请选择部门"
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    allow-clear
                                >
                                    <a-select-option v-for="item in organizationList" :key="item.id" :value="item.id">
                                        {{ item.uniqueName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="上手背书人">
                                <a-input v-model="formData.prevEndorser" placeholder="请输入上手背书人" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="下手背书人">
                                <a-input v-model="formData.nextEndorser" placeholder="请输入下手背书人" />
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="24" :md="24" :sm="24">
                            <a-form-model-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                <a-textarea v-model="formData.remarks" :rows="4" placeholder="" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>

                <div class="title">附件</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="24" :md="24" :sm="24">
                            <a-form-model-item :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" label="上传">
                                <FileUpload :multiple="true" @uploaded="uploaded">
                                    <a-button type="primary">附件上传</a-button>
                                </FileUpload>

                                <Padding />

                                <a-table bordered :data-source="fileList" :pagination="false" rowKey="id">
                                    <a-table-column title="文件名">
                                        <template slot-scope="text">
                                            <a :href="text.completePath" target="_blank">{{ text.name }}</a>
                                        </template>
                                    </a-table-column>
                                    <a-table-column title="操作" align="center" width="80px">
                                        <template slot-scope="text, record, index">
                                            <a href="#" class="danger" @click.prevent="remove(index)">删除</a>
                                        </template>
                                    </a-table-column>
                                </a-table>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>

                <div class="center">
                    <a-space>
                        <a-button type="primary" :loading="saving" @click="handleSave">保存</a-button>
                        <a-button @click="handleClose">关闭</a-button>
                    </a-space>
                </div>
            </a-form-model>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import organization from "@/mixins/organization";
import ContractSelector from "@/components/contract-selector";
import FileUpload from "@/components/file-upload";
import { getFileList } from "@/api/file";
import { billAdd, billUpdate, fetchBillDetail } from "@/api/finance/bill-library";

export default {
    name: "BillForm",
    mixins: [organization],
    components: {
        ContractSelector,
        FileUpload
    },
    data() {
        return {
            saving: false,
            formData: {
                billType: null,
                billNo: "",
                drawer: "",
                bankName: null,
                payBank: null,
                payee: "",
                issueDate: null,
                dueDate: null,
                amount: "",
                receiveDate: null,
                receiveContractId: null,
                receiveContractName: "",
                receiveDeptId: null,
                prevEndorser: "",
                nextEndorser: "",
                remarks: ""
            },
            fileList: []
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        bankList() {
            return this.findDataDict("bank") || [];
        },
        billTypeList() {
            return this.findDataDict("billType") || [];
        },
        isEdit() {
            return !!this.$route.query.id;
        },
        receiveDeptName() {
            const dept = this.organizationList.find(item => item.id === this.formData.receiveDeptId);
            return dept ? dept.uniqueName : "";
        }
    },
    mounted() {
        if (this.isEdit) {
            this.loadDetail();
        }
    },
    methods: {
        async loadDetail() {
            try {
                const data = await fetchBillDetail(this.$route.query.id) || {};
                const f = this.formData;
                f.billType = data.billType;
                f.billNo = data.billNo;
                f.drawer = data.drawer;
                f.bankName = data.bankName;
                f.payBank = data.payBank;
                f.payee = data.payee;
                f.issueDate = data.issueDate ? moment(data.issueDate) : null;
                f.dueDate = data.dueDate ? moment(data.dueDate) : null;
                f.amount = data.amount != null ? String(data.amount) : (data.issueAmount != null ? String(data.issueAmount) : "");
                f.receiveDate = data.receiveDate ? moment(data.receiveDate) : null;
                f.receiveContractId = data.receiveContractId;
                f.receiveContractName = data.receiveContractName;
                f.receiveDeptId = data.receiveDeptId;
                f.prevEndorser = data.prevEndorser;
                f.nextEndorser = data.nextEndorser;
                f.remarks = data.remarks;
                if (data.attachmentFiles && data.attachmentFiles.length) {
                    // 详情接口直接返回 attachmentFiles 数组
                    this.fileList = data.attachmentFiles.map(item => ({
                        id: item.id,
                        name: item.name,
                        completePath: item.completePath
                    }));
                } else if (data.attachments) {
                    const ids = data.attachments.split(",").filter(Boolean);
                    // 先保留文件ID，避免保存时丢失
                    this.fileList = ids.map(id => ({ id }));
                    try {
                        // 查询文件信息用于展示文件名
                        const files = await getFileList(data.attachments);
                        if (Array.isArray(files) && files.length) {
                            this.fileList = files.map(item => ({
                                id: item.id,
                                name: item.name,
                                completePath: item.completePath
                            }));
                        }
                    } catch (e) {
                        console.error("加载附件信息失败", e);
                    }
                }
            } catch (e) {
                console.error("加载票据详情失败", e);
            }
        },
        // 附件上传完成
        uploaded(list) {
            this.fileList = [...this.fileList, ...list];
        },
        remove(index) {
            this.fileList.splice(index, 1);
        },
        formatDate(value) {
            return value ? value.format("YYYY-MM-DD") : null;
        },
        // 选择收票项目
        onSelectProject(project) {
            this.formData.receiveContractId = project.id;
            this.formData.receiveContractName = project.name;
        },
        async handleSave() {
            if (!this.formData.billType) {
                this.$message.warning("请选择票据类型");
                return;
            }
            if (!this.formData.billNo) {
                this.$message.warning("请输入票据号码");
                return;
            }
            if (!this.formData.amount) {
                this.$message.warning("请输入出票金额");
                return;
            }
            if (isNaN(Number(this.formData.amount))) {
                this.$message.warning("出票金额必须为数字");
                return;
            }

            const f = this.formData;
            const payload = {
                billType: f.billType,
                billNo: f.billNo,
                drawer: f.drawer,
                bankName: f.bankName,
                payBank: f.payBank,
                payee: f.payee,
                issueDate: this.formatDate(f.issueDate),
                dueDate: this.formatDate(f.dueDate),
                amount: Number(f.amount),
                receiveDate: this.formatDate(f.receiveDate),
                receiveContractId: f.receiveContractId,
                receiveContractName: f.receiveContractName,
                receiveDeptId: f.receiveDeptId,
                receiveDeptName: this.receiveDeptName,
                prevEndorser: f.prevEndorser,
                nextEndorser: f.nextEndorser,
                remarks: f.remarks,
                attachments: this.fileList.map(item => item.id).join(",")
            };

            this.saving = true;
            try {
                if (this.isEdit) {
                    await billUpdate({ ...payload, id: this.$route.query.id });
                } else {
                    await billAdd(payload);
                }
                this.$message.success("保存成功");
                this.handleClose();
            } catch (e) {
                console.error("保存失败", e);
                this.$message.error("保存失败");
            } finally {
                this.saving = false;
            }
        },
        handleClose() {
            this.$router.back();
        }
    }
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
}
</style>
